import {
  CommandGetOrganizationInvoice,
  GetOrganizationInvoiceParams,
} from "./commands/cmdGetOrganizationInvoice";
import { CommandExportOrganizationInvoice } from "./commands/cmdExportOrganizationInvoice";
import { Invoice } from "src/shared/models/invoice.model";

export class InvoiceService {
  async getOrganizationInvoice(
    organizationId: number,
    params?: GetOrganizationInvoiceParams,
  ): Promise<Invoice> {
    try {
      const cmd = new CommandGetOrganizationInvoice();
      return await cmd.run(organizationId, params);
    } catch (error) {
      console.error(`Failed to fetch invoice for organization ${organizationId}:`, error);
      throw error;
    }
  }

  async exportOrganizationInvoice(
    organizationId: number,
    params?: GetOrganizationInvoiceParams,
  ): Promise<void> {
    try {
      const cmd = new CommandExportOrganizationInvoice();
      await cmd.run(organizationId, params);
    } catch (error) {
      console.error(`Failed to export invoice for organization ${organizationId}:`, error);
      throw error;
    }
  }
}
